import { api } from "../../lib/api";
export const updateProjectAssetDetails = async (projectId, queryParams, projectAssetsUpdateRequest) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    if ("operationType" in queryParams) {
        params.append("operationType", queryParams.operationType);
    }
    const { data } = await api.patch(`/projects/${projectId}/assets${params.toString() ? "?" + params.toString() : ""}`, projectAssetsUpdateRequest);
    return { data };
};
